import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_8: FaireProductEntity = {
  token: "driftless-studios-8",
  type: "product",
  name: "20 oz I Love This Place Customizable Products Coffee Mug",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/14d099b0434445756389a54322940c7b119feb0c502e0ce4ba7fa53b06721946.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 16.5,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
